/**
 * useViewportHeight — returns the visual-viewport height in pixels, updated on
 * every software-keyboard resize event. Falls back to window.innerHeight in
 * environments without visualViewport (test environments, very old browsers).
 * Spec: docs/responsive-redesign.md § PWA Environment Concerns — On-screen keyboard
 */
import { useState, useEffect } from 'react'

export function useViewportHeight(): number {
  const [h, setH] = useState<number>(() => {
    if (typeof window === 'undefined') return 0
    return window.visualViewport?.height ?? window.innerHeight
  })

  useEffect(() => {
    if (typeof window === 'undefined') return

    const vv = window.visualViewport
    if (!vv) return

    const handler = () => setH(vv.height)
    vv.addEventListener('resize', handler)
    return () => vv.removeEventListener('resize', handler)
  }, [])

  return h
}
